// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forbidden--cE8WA{font-size:20px;padding:20px;text-align:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/components/Forbidden/styles.module.scss"],"names":[],"mappings":"AAAA,kBACI,cAAA,CACA,YAAA,CACA,iBAAA,CACA,sBAAA","sourcesContent":[".forbidden {\n    font-size: 20px;\n    padding: 20px; \n    text-align: center;\n    justify-content: center; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forbidden": `forbidden--cE8WA`
};
export default ___CSS_LOADER_EXPORT___;
